export let APP_SETTINGS = {
  AuthorApiUrl: '',
  AuthorFollowApiUrl: '',
  AuthorizationApiUrl: '',
  AuthorizationI3TokenUrl: '',
  BackofficeApiUrl: '',
  BasicUserSettingsApiUrl: '',
  BrokersApiUrl: '',
  CalendarSettingsApiUrl: '',
  CalendarI3ApiUrl: '',
  CalendarApiUrl: '', 
  ConfigurationApiUrl: '',
  EditorialToolsApiUrl: '',
  EventFollowApiUrl: '',
  LeadApiUrl: '',
  MarketToolBOApiUrl: '',
  MarketToolI3ApiUrl: '',
  MasterDataApiUrl: '',
  NewsletterTypesApiUrl: '',
  PaymentTransactionApiUrl: '',
  PostApiUrl: '',
  PostI3ApiUrl: '',
  PostTranslationsConfig: null,
  RatesTableSettingsApiUrl: '',
  StaticContentRefresh: '',
  StaticContentUrl: '',
  TagApiUrl: '',
  UsersApiUrl: '',
  UserFunctionsApiUrl: '',
  UserFunctionsApiKey: '',
  TranslationBOApiUrl: '',
  UserNewsletterApiUrl: '',
  SignalsConfig: null,
  SignalBoConfig: null,
  EmbedTweetEndpoint: '',
  WebVitalsApiUrl: '',
  WebVitalsApiToken: '',
  StorageApiUrl: '',
  SupportedCultures: null,
  ScheduledApiUrl: '',
  BOEnvironment: '',
  UserPayApiUrl: '',
  DeleteAccountApiUrl: '',
  DiscordBotApiUrl: '',
  DiscordGetMemberByUserIdUrl: '',
}



// WEBPACK FOOTER //
// ./src/app/shared/models/backofficeConfiguration.ts